import { Box } from '@hivebrite/design-system/Box';
import { Divider } from '@hivebrite/design-system/Divider';

import { StyledCard } from 'hb-react/shared/apps/Memberships/components/MembershipCard';

import CardHeader from './CardHeader';
import PurchaseOption from './PurchaseOption';
import RenewalPolicy from './RenewalPolicy';

const PurchaseOptions = ({ purchaseOptions = [], onPaymentOptionChange }) => (
  <Box flexDirection="column" width="100%">
    <Box font="h3-semibold">{s__('Memberships|Purchase Options')}</Box>
    <Divider borderBottomColor="horizon" mt={4} mb={5} width="100%" />
    {purchaseOptions.map((purchaseOption, i) => (
      <Box
        key={`purchase-option-${purchaseOption.id}`}
        data-testid={`purchase-option-${purchaseOption.id}`}
        flexDirection="column"
      >
        <PurchaseOption
          {...purchaseOption}
          onSelect={() => onPaymentOptionChange(purchaseOption)}
        />
        {i + 1 < purchaseOptions.length && (
          <Divider borderBottomColor="horizon" mt={4} mb={5} width="100%" />
        )}
      </Box>
    ))}
  </Box>
);

export const Membership = ({
  onAutomaticRenewal,
  onPaymentOptionChange,
  membership,
}) => {
  const { brandBarColor, payment_options: paymentOptions = [] } = membership;

  const withMultiplePaymentOptions = paymentOptions.length > 1;

  return (
    <StyledCard brandBarColor={brandBarColor}>
      <Box flexDirection="column">
        <CardHeader
          membership={membership}
          withMultiplePaymentOptions={withMultiplePaymentOptions}
        />
        {withMultiplePaymentOptions && (
          <Box mt={8}>
            <PurchaseOptions
              purchaseOptions={paymentOptions}
              onPaymentOptionChange={onPaymentOptionChange}
            />
          </Box>
        )}
        <RenewalPolicy
          membership={membership}
          onAutomaticRenewal={onAutomaticRenewal}
        />
      </Box>
    </StyledCard>
  );
};
